import { theme } from "../styles/theme";

const LIMITES_ROL = {
  director: 8,
  tutor: 8,
  evaluador: 10
};

const obtenerEstadoRol = (rol, valor) => {
  const limite = LIMITES_ROL[rol];

  if (!limite) {
    return {
      background: "#f8fafc",
      border: theme.colors.border,
      color: theme.colors.subtext
    };
  }

  if (valor >= limite) {
    return {
      background: "#fde8e8",
      border: "#f5b8b8",
      color: "#b42318"
    };
  }

  if (valor >= Math.max(limite - 2, 1)) {
    return {
      background: "#fff1e6",
      border: "#f7c59f",
      color: "#c26a2d"
    };
  }

  return {
    background: "#f8fafc",
    border: theme.colors.border,
    color: theme.colors.subtext
  };
};

function DocenteCard({ docente, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: theme.colors.panelBg,
        padding: "18px",
        borderRadius: "14px",
        cursor: "pointer",
        transition: "0.2s",
        border: `1px solid ${theme.colors.border}`,
        boxShadow: "0 12px 24px rgba(15, 23, 42, 0.08)"
      }}
    >
      <div style={styles.header}>
        <h4 style={styles.name}>{docente.nombre}</h4>
        <span style={styles.totalBadge}>{docente.total}</span>
      </div>

      <p style={styles.helper}>Participaciones historicas registradas</p>

      <div style={styles.roleGrid}>
        <span style={{ ...styles.roleChip, ...obtenerEstadoRol("director", docente.director) }}>Tut. {docente.director}</span>
        <span style={{ ...styles.roleChip, ...obtenerEstadoRol("evaluador", docente.evaluador) }}>Eval. {docente.evaluador}</span>
      </div>

      <div style={styles.footer}>
        <span style={styles.link}>Ver detalle</span>
      </div>
    </div>
  );
}

export default DocenteCard;

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "10px"
  },
  name: {
    margin: 0,
    color: theme.colors.text,
    fontSize: "16px"
  },
  totalBadge: {
    minWidth: "36px",
    textAlign: "center",
    padding: "6px 10px",
    borderRadius: "999px",
    background: theme.colors.primarySoft,
    color: theme.colors.primary,
    fontWeight: 800,
    fontSize: "13px"
  },
  helper: {
    margin: "0 0 14px",
    color: theme.colors.subtext,
    fontSize: "13px"
  },
  roleGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px"
  },
  roleChip: {
    padding: "8px 10px",
    borderRadius: "10px",
    border: `1px solid ${theme.colors.border}`,
    fontWeight: 700,
    fontSize: "13px"
  },
  footer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px"
  },
  link: {
    color: theme.colors.primary,
    fontSize: "13px",
    fontWeight: 700
  }
};
